const LABELS = {
  rfc: 'RFC',
  tax_id: 'Pasaporte',
};

const HELPERS = {
  rfc: 'El RFC lo emite el SAT. Lo encuentras en tu constancia de situación fiscal o en sat.gob.mx.',
  tax_id: 'Introduce tu número de identificación fiscal (NIF, DNI, SSN, NIT...)',
};

// Mismo patrón que el value object Rfc del backend
const RFC_PATTERN = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/i;

const GENERIC_ERROR = 'No hemos podido guardar el documento, inténtalo de nuevo.';
const INVALID_RFC_ERROR = 'Revisa tu RFC: son 3 o 4 letras, 6 dígitos y 3 caracteres más.';

const fiscalDocument = () => {
  const form = document.querySelector('.js-fiscal-document');
  if (!form) return;

  const typeSelect = form.querySelector('.js-fiscal-document-type');
  const valueInput = form.querySelector('.js-fiscal-document-value');
  const label = form.querySelector('.js-fiscal-document-label');
  const helper = form.querySelector('.js-fiscal-document-helper');
  const error = form.querySelector('.js-fiscal-document-error');
  const submit = form.querySelector('.js-fiscal-document-submit');
  const success = document.querySelector('.js-fiscal-document-success');

  const showError = (message) => {
    error.textContent = message;
    error.classList.remove('d-none');
  };

  const hideError = () => error.classList.add('d-none');

  typeSelect.addEventListener('change', () => {
    const type = typeSelect.value;
    label.textContent = LABELS[type];
    helper.textContent = HELPERS[type];
    valueInput.value = '';
    hideError();
  });

  submit.addEventListener('click', async () => {
    const value = valueInput.value.trim();
    if (!value) {
      showError(`Introduce tu ${LABELS[typeSelect.value]}.`);
      return;
    }

    if (typeSelect.value === 'rfc' && !RFC_PATTERN.test(value)) {
      showError(INVALID_RFC_ERROR);
      return;
    }

    hideError();
    submit.disabled = true;

    try {
      const formData = new FormData();
      formData.append('fiscal_document_type', typeSelect.value);
      formData.append('fiscal_document', value);

      const response = await fetch('/api/v4/user', {method: 'POST', body: formData});
      if (!response.ok) {
        showError(GENERIC_ERROR);
        submit.disabled = false;
        return;
      }

      form.classList.add('d-none');
      success.classList.remove('d-none');
    } catch (e) {
      showError(GENERIC_ERROR);
      submit.disabled = false;
    }
  });
};

export { fiscalDocument };
